/**
 * <s-wishlist-toggle> — Heart button that saves or removes one product from the wishlist.
 *
 * Markup: a descendant button with commandfor="<this element's id>" command="--toggle".
 * Attributes: data-handle and data-url (product handle and URL, written by Liquid).
 * The button's aria-pressed reflects whether the product is saved.
 */
import { hasItem, subscribe, toggleItem } from '@theme/wishlist-store';

class SWishlistToggle extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    const { signal } = this.#ac;

    this.addEventListener('command', (event) => {
      if (event.command !== '--toggle') return;
      toggleItem({ handle: this.dataset.handle, url: this.dataset.url });
    }, { signal });

    subscribe(() => this.#sync(), signal);
    this.#sync();
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  #sync() {
    const button = this.querySelector('button');
    if (button) button.setAttribute('aria-pressed', String(hasItem(this.dataset.handle)));
  }
}

if (!customElements.get('s-wishlist-toggle')) {
  customElements.define('s-wishlist-toggle', SWishlistToggle);
}
